export default __webpack_public_path__ + "static/media/thank-you-hearts-bottom-right.a5146809.svg";